module.exports = __webpack_public_path__ + "resources/btn-primary-bg.31d3111aaec570cf.png";